import { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { useSettings } from '../App/CartContext';
import { Button } from '@wordpress/components';
import 'swiper/css';

const ProductSlider = ({ products = [] }) => {
  const { settings, loading, addFromSlider } = useSettings();
  const swiperRef = useRef(null);
  const showNavButtons = products?.length > 1;

  if (!products || !products.length) return null;

  const showImage = settings?.enable_slider_img === 'true';
  const showName = settings?.enable_slider_pro_name === 'true';
  const showPrice = settings?.enable_slider_pro_price === 'true';
  const showButton = settings?.enable_slider_btn === 'true';
  
  if (!showImage && !showName && !showPrice) return null;

  const enable_desktop = settings?.slid_enable_desk === 'true';
  const enable_mobile = settings?.slid_enable_mob === 'true';
  const isMobile = window.matchMedia('(max-width: 768px)').matches;

  if (isMobile) {
    if (!enable_mobile) return null;
  } else {
    if (!enable_desktop) return null;
  }

  return (
    <div style={{ overflow: 'hidden' }}>
      <Swiper
        modules={[Autoplay]}
        slidesPerView={1}
        spaceBetween={0}
        loop={true}
        allowTouchMove={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
          if (swiper?.wrapperEl) {
            swiper.wrapperEl.style.display = 'flex';
            swiper.wrapperEl.style.flexDirection = 'row';
          }
        }}
        style={{
          width: '100%',
          '--nav-btn-bg-clr': settings?.cbc_color,
          '--nav-btn-svg-clr': settings?.btn_text_color,
          '--nav-btn-hover-bg-clr': settings?.cbh_color,
          '--nav-btn-hover-svg-clr': settings.btnh_color,
        }}
      >
        {products.map((p) => (
          <SwiperSlide
            key={p.id}
            style={{
              width: '100%',
              flexShrink: 0,
            }}
          >
            <div 
              className="slider-main"
              style={{
                backgroundColor: settings?.slider_back_color,
              }}
            >
              {/* PREV BUTTON */}
              {showNavButtons &&
                <Button
                  onClick={() => swiperRef.current?.slidePrev()}
                  className="swiper-Btn"
                >
                  <svg
                    className="swiper-svg"
                    width="20"
                    height="20"
                    viewBox="0 0 32 32"
                    style={{ display: 'block' }}
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M32 15H3.41l8.29-8.29-1.41-1.42-10 10a1 1 0 0 0 0 1.41l10 10 1.41-1.41L3.41 17H32z" />
                  </svg>
                </Button>
              }

              {/* IMAGE */}
              {showImage && 
                <a href={p.url} style={{ flexShrink: 0 }}>
                  <img
                    src={p.image}
                    alt={p.name}
                    style={{
                      width: settings?.slider_img_width + 'px',
                      height: settings?.slider_img_width + 'px',
                      objectFit: 'cover',
                      borderRadius: 6,
                    }}
                  />
                </a>
              }

              {/* INFO */}
              <div style={{ flex: 1 }}>
                {showName && 
                  <div
                    style={{
                      fontSize: settings?.slider_font_size + 'px',
                      color: settings?.slider_pro_title_color,
                      fontWeight: 600,
                      marginBottom: 4,
                    }}
                  >
                    {p.name}
                  </div>
                }
                {showPrice &&
                  <div
                    style={{
                      fontSize: settings?.slider_font_size + 'px',
                      color: '#333',
                    }}
                  >
                    {settings?.currency}
                    {Number(p.price).toFixed(2)}
                  </div>
                }
              </div>

              {/* ADD */}
              {showButton &&
                <Button
                  disabled={loading}
                  className="slider-add-btn"
                  onClick={() => addFromSlider(p.id)}
                  style={{
                    '--slider-btn-bg-clr': settings?.slider_btn_back_color,
                    '--slider-btn-txt-clr': settings?.slider_btn_text_color,
                    '--slider-btn-hvr-bg-clr': settings?.slider_btn_back_hover_color,
                    '--slider-btn-txt-hvr-clr': settings?.slider_btn_hover_text_color,
                    padding: '6px 12px',
                    borderRadius: 6,
                    fontSize: settings?.slider_font_size + 'px',
                    textDecoration: 'none',
                    whiteSpace: 'nowrap',
                  }}
                >
                  + Add
                </Button>
              }

              {/* NEXT BUTTON */}
              {showNavButtons &&
                <Button
                  onClick={() => swiperRef.current?.slideNext()}
                  className="swiper-Btn"
                >
                  <svg
                    className="swiper-svg"
                    width="20"
                    height="20"
                    viewBox="0 0 32 32"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ display: 'block' }}
                  >
                    <path
                      d="M0 17h28.59l-8.29 8.29 1.41 1.42 10-10a1 1 0 0 0 0-1.41l-10-10-1.41 1.41L28.59 15H0z"
                    />
                  </svg>
                </Button>
              }
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ProductSlider;
